import { getFacePhotoThunk } from '../../../../../store/workspace/thunks';
import { KYC_APPROVED, KYC_NOT_APPROVED } from '../../constants';
import { CameraIcon } from '../../../../../assets/icons/common';
import { useDispatch, useSelector } from '../../../../../store/store';
import { selectUserId } from '../../../../../store/auth/selectors';
import Button from '../../../../../components/Button';
import InfoCard from '../../components/InfoCard';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';
import KYCWizard from './KYCWizard';
import {
    selectFacePhoto,
    selectProfileData,
} from '../../../../../store/workspace/selectors';

/** Shows the photo held on file and the applicant's KYC standing. */
function Identifying() {
    const dispatch = useDispatch();
    const userId = useSelector(selectUserId);
    const facePhoto = useSelector(selectFacePhoto);
    const kycStatus = useSelector(selectProfileData)?.kyc || '';
    const [isWizardOpen, setIsWizardOpen] = useState(false);

    const loadFacePhoto = () => {
        if (!userId) return;
        dispatch(getFacePhotoThunk(`${userId}/face.png`));
    };

    useEffect(() => {
        if (facePhoto) return;
        loadFacePhoto();
    }, [userId]);

    /** A completed KYC run replaces the photo on file, so it is fetched again. */
    const onVerified = () => {
        loadFacePhoto();
        setIsWizardOpen(false);
    };

    return (
        <div className={styles.wrapper}>
            <InfoCard title='Personal photo'>
                {facePhoto ? <div className={styles.face}>
                    <img src={facePhoto} alt='' />
                </div> : <div className={styles.empty}>
                    <CameraIcon />
                    <span>No data</span>
                </div>}
            </InfoCard>

            <InfoCard title='KYC status'>
                <span className={styles.status} data-kyc-status={kycStatus}>
                    {kycStatus === KYC_APPROVED && 'Approved'}
                    {kycStatus === KYC_NOT_APPROVED && 'Not approved'}
                </span>
                {kycStatus === KYC_NOT_APPROVED && <Button
                    size='sm'
                    type='Primary'
                    text='KYC now'
                    className={styles.kycBtn}
                    onClick={() => setIsWizardOpen(true)}
                />}
            </InfoCard>

            {isWizardOpen && <KYCWizard
                onVerified={onVerified}
                onClose={() => setIsWizardOpen(false)}
            />}
        </div>
    );
};

export default Identifying;
